let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h8eeI")).then(() => parcelRequire('kGiTR'));